<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em !important;">I would like to thank Elaine and Sharon for their specialised input for this book, which has been very helpful.</p><br/>
<p style="text-indent:0em !important;">I would like to thank Nakita for reading <em>Shadows in the Rainbows</em> first, which she enjoyed immensely.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?40c08214